// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_resource_class_enum */
var InvResourceClassEnum;
(function (InvResourceClassEnum) {
    InvResourceClassEnum["INGREDIENT"] = "INGREDIENT";
    InvResourceClassEnum["AUXILIARY_MATERIAL"] = "AUXILIARY_MATERIAL";
    InvResourceClassEnum["CONSUMABLE_SUPPLY"] = "CONSUMABLE_SUPPLY";
    InvResourceClassEnum["TRACKED_EQUIPMENT"] = "TRACKED_EQUIPMENT";
    InvResourceClassEnum["FOOD_INGREDIENT"] = "FOOD_INGREDIENT";
    InvResourceClassEnum["PROCESSING_AID"] = "PROCESSING_AID";
})(InvResourceClassEnum || (InvResourceClassEnum = {}));
;
export default InvResourceClassEnum;
/** Zod schema for inv_resource_class_enum */
export const invResourceClassEnum = z.nativeEnum(InvResourceClassEnum);
//# sourceMappingURL=InvResourceClassEnum.js.map